import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    q: 'What is RaffleBowl?',
    a: 'RaffleBowl is a split-the-pot raffle platform where ticket sales form the prize pool. Winners are selected through transparent, verifiable draws and receive their share instantly.',
  },
  {
    q: 'How do I enter a raffle?',
    a: 'Browse available raffles, select one you like, choose how many tickets you want, and complete payment. Your tickets are confirmed immediately and you can track them from your dashboard.',
  },
  {
    q: 'How are winners selected?',
    a: 'Winners are selected using a cryptographically secure random number generator. Each ticket has an equal chance of winning, and draw results are publicly verifiable.',
  },
  {
    q: 'How does the prize pool work?',
    a: 'The prize pool (Current Draw Pot) is funded entirely by ticket sales for each draw period. A small platform fee and organizer share are deducted, and the remainder is split among winners according to the raffle\'s prize distribution.',
  },
  {
    q: 'When do draws happen?',
    a: 'Each raffle has its own draw schedule — one-time, daily, weekly, monthly, or yearly. The next draw date and countdown are displayed on each raffle page.',
  },
  {
    q: 'How do I receive my winnings?',
    a: 'Winnings are credited to your RaffleBowl wallet instantly after a draw. You can withdraw funds to your bank account or mobile money at any time from the Wallet page.',
  },
  {
    q: 'Are there any fees?',
    a: 'A small platform fee is applied to each draw\'s prize pool. Withdrawals may also have a small processing fee depending on your withdrawal method. All fees are transparently displayed before you confirm any transaction.',
  },
  {
    q: 'What is the affiliate program?',
    a: 'You can earn commissions by referring new users to RaffleBowl. Share your unique referral code, and when referred users purchase tickets, you earn a percentage of the platform fee. Visit the Affiliate page for details.',
  },
  {
    q: 'Is my payment information secure?',
    a: 'Yes. All payments are processed through Paystack, a PCI-DSS compliant payment provider. RaffleBowl never stores your card details directly.',
  },
  {
    q: 'Can I get a refund on purchased tickets?',
    a: 'Ticket purchases are final and non-refundable once confirmed. Please review your selection carefully before completing payment.',
  },
  {
    q: 'How do I contact support?',
    a: 'Visit the Contact Us page to send us a message, or email us directly. We aim to respond within 24 hours.',
  },
];

export const FAQ: React.FC = () => {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-2">Frequently Asked Questions</h1>
      <p className="text-gray-500 dark:text-gray-400 mb-8">Everything you need to know about RaffleBowl.</p>

      <div className="space-y-3">
        {faqs.map((faq, i) => (
          <div key={i} className="bg-white dark:bg-gray-900 border border-gray-100 dark:border-gray-800 rounded-2xl shadow-sm overflow-hidden">
            <button
              onClick={() => setOpen(open === i ? null : i)}
              className="w-full flex items-center justify-between px-6 py-4 text-left"
            >
              <span className="font-semibold text-gray-900 dark:text-gray-100 pr-4">{faq.q}</span>
              <ChevronDown className={`h-5 w-5 text-gray-400 dark:text-gray-500 flex-shrink-0 transition-transform ${open === i ? 'rotate-180' : ''}`} />
            </button>
            {open === i && (
              <div className="px-6 pb-5 text-gray-600 dark:text-gray-400 text-sm leading-relaxed">
                {faq.a}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
